import { Box, Checkbox, ListItemText, MenuItem } from "@mui/material";
import { SelectInputProps } from "@mui/material/Select/SelectInput";
import React, { RefObject, useCallback } from "react";
import { Check as CheckIcon } from "@mui/icons-material";
import { styled } from "@mui/system";
import { colors } from "~/theme";

const StyledCheckbox = styled(Checkbox)({
    "&.Mui-checked": {
        "& .MuiIconButton-label": {
            backgroundColor: colors.black03,
            borderRadius: "4px",
        },
    },

    color: colors.black10,
});
const StyledListItemText = styled(ListItemText)({
    whiteSpace: "normal",
});

export const MultipleMenuItem = React.forwardRef(
    (
        {
            option,
            options,
            onChange,
        }: React.PropsWithChildren<{
            option: string;
            options: string[];
            onChange?: SelectInputProps["onChange"];
        }>,
        ref,
    ) => {
        const onClick = useCallback(
            (e: React.SyntheticEvent) => {
                const changeEvent = e as unknown as Event & {
                    target: { value: string[]; name: string };
                };
                const selected = options.includes(option);

                if (selected) {
                    changeEvent.target.value = options.filter(
                        (el) => el !== option,
                    );
                } else {
                    changeEvent.target.value = options.concat(option);
                }

                onChange?.(changeEvent, null);
            },
            [options, option, onChange],
        );

        return (
            <MenuItem
                value={option}
                ref={ref as RefObject<HTMLLIElement>}
                onClick={onClick}
            >
                <StyledCheckbox
                    checkedIcon={
                        <Box color={colors.black}>
                            <CheckIcon />
                        </Box>
                    }
                    checked={options.includes(option)}
                />
                <StyledListItemText primary={option} />
            </MenuItem>
        );
    },
);
